import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import SecaStart from './surveys/seca/Start';
import SecaSurvey from './surveys/seca/Survey';
import SecaCompleted from './surveys/seca/Completed';
import ValidateSecaToken from './surveys/seca/ValidateSecaToken';
import Translate from './Translate';
import NotFound from './NotFound';

const Root = () => {
  return (
    <BrowserRouter>
      <Translate>
        <Switch>
          <Route path="/seca/completed" component={SecaCompleted} />
          <Route path="/seca/:token">
            <ValidateSecaToken>
              <Switch>
                <Route path="/seca/:token/:page" component={SecaSurvey} />
                <Route path="/seca/:token" component={SecaStart} />
              </Switch>
            </ValidateSecaToken>
          </Route>
          <Route path="*" component={NotFound}/>
        </Switch>
      </Translate>
    </BrowserRouter>
  );
}

export default Root;
